module.exports = __webpack_public_path__ + "img/icon-rubbish.9d8c3a41.svg";